import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, CheckCircle2, Lock, Zap, HeadphonesIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_PACK = 'https://www.tubienestarinterno.com/cart/53346665300305:1';
const CHECKOUT_SOLO = 'https://www.tubienestarinterno.com/cart/53346355937617:1';
export function DecisionSection() {
  const goToCheckoutPack = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_PACK;
  };
  const goToCheckoutSolo = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_SOLO;
  };
  const checklistItems = ['Método DOG-CALM 7 Días.', 'Manual Anti-Ansiedad (Bump).', 'Pack de 3 Bonos Regalo (Lluvia, Dieta, Cafetero).', 'Acceso Vitalicio y Sin Suscripciones.'];
  return <section className="pt-8 pb-12 px-5" data-id="element-81">
      <div className="max-w-lg mx-auto text-center flex flex-col items-center" data-id="element-82">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 leading-tight" data-id="element-83">
          Únete a los +5.700 dueños que ya disfrutan de sus paseos.
        </h2>

        <div className="w-full mb-4 relative" data-id="element-84">
          {/* Badge */}
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20" data-id="element-85">
            <span className="bg-accent text-white text-xs font-bold px-3 py-1 rounded-full shadow-md border border-white/20 whitespace-nowrap" data-id="element-86">
              Opción recomendada 🔥
            </span>
          </div>

          <Button onClick={goToCheckoutPack} fullWidth className="py-8 pt-10 text-lg shadow-[0_0_25px_rgba(39,174,96,0.4)]" data-id="element-87">
            <span className="flex flex-col items-center gap-2" data-id="element-88">
              <span className="font-extrabold text-lg md:text-xl leading-tight" data-id="element-89">
                LLEVARME EL PACK COMPLETO (DOG-CALM + CÓDIGO DEL SILENCIO + 3
                BONOS GRATIS)
              </span>
              <span className="text-base font-semibold opacity-90" data-id="element-90">
                — 14,85€
              </span>
            </span>
          </Button>
        </div>

        <p className="text-white/70 text-sm mb-6 font-medium" data-id="element-91">
          Valor total 113€. Ahorras 98,15€ hoy. Entrega inmediata.
        </p>

        {/* Checklist */}
        <div className="w-full text-left mb-8 space-y-2.5 px-2" data-id="element-92">
          {checklistItems.map((item, index) => <div key={index} className="flex items-center gap-2.5" data-id="element-93">
              <CheckCircle2 className="w-4 h-4 text-accent flex-shrink-0" data-id="element-94" />
              <span className="text-white/70 text-sm" data-id="element-95">{item}</span>
            </div>)}
        </div>

        <a href={CHECKOUT_SOLO} onClick={e => {
        e.preventDefault();
        goToCheckoutSolo();
      }} className="text-white/40 text-base underline underline-offset-4 hover:text-white/60 transition-colors mb-10" data-id="element-96">
          No gracias, solo probaré DOG-CALM por 9,95€.
        </a>

        {/* Trust Box Guarantee — below secondary link */}
        <div className="bg-[rgba(245,166,35,0.15)] border border-gold rounded-xl p-6 w-full shadow-lg relative overflow-hidden" data-id="element-97">
          {/* Subtle gold glow */}
          <div className="absolute top-0 right-0 w-32 h-32 bg-gold/10 blur-2xl rounded-full -z-10" data-id="element-98"></div>

          <div className="flex flex-col items-center text-center mb-5" data-id="element-99">
            <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center flex-shrink-0 border border-gold/30 mb-4" data-id="element-100">
              <ShieldCheck className="w-6 h-6 text-gold" data-id="element-101" />
            </div>
            <h3 className="text-white font-extrabold text-xl mb-2" data-id="element-102">
              Garantía Profesional de Resultados: 14 Días.
            </h3>
            <p className="text-white/70 text-sm leading-relaxed" data-id="element-103">
              <strong className="text-white" data-id="element-104">
                Como especialistas en comportamiento animal, nuestro compromiso
                es su éxito.
              </strong>{' '}
              Si tras aplicar el Protocolo DOG-CALM durante 14 días no observa
              una mejora técnica en la reactividad de la correa, le reintegramos
              el 100% de su inversión de forma inmediata.
            </p>
          </div>

          {/* Trust Badges */}
          <div className="flex items-center justify-between pt-4 border-t border-white/5" data-id="element-105">
            <div className="flex items-center gap-1.5" data-id="element-106">
              <Lock className="w-3.5 h-3.5 text-white/40" data-id="element-107" />
              <span className="text-white/40 text-xs font-medium" data-id="element-108">
                Pago Encriptado SSL
              </span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-109">
              <Zap className="w-3.5 h-3.5 text-white/40" data-id="element-110" />
              <span className="text-white/40 text-xs font-medium" data-id="element-111">
                Entrega en 10 seg
              </span>
            </div>
            <div className="flex items-center gap-1.5 hidden sm:flex" data-id="element-112">
              <HeadphonesIcon className="w-3.5 h-3.5 text-white/40" data-id="element-113" />
              <span className="text-white/40 text-xs font-medium" data-id="element-114">
                Soporte 24/7
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}